import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { pagesData, pagesState, PagesAsync } from './controller';
import { Accordion } from 'react-bootstrap';

import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';


export function FAQ() {

    const dispatch = useDispatch();
    const pages_state = useSelector(pagesState);
    const pages_data = useSelector(pagesData);

    useEffect(() => {
        dispatch(PagesAsync());
    }, []);


    function CustomToggle({ children, eventKey }) {
        const decoratedOnClick = useAccordionButton(eventKey, () =>
            console.log(''),
        );

        return (
            <button
                type="button"
                style={{
                    margin: '0',
                    width: '100%',
                    textAlign: 'start',
                    backgroundColor: '#e9e9e9',
                    borderRadius: '5px',
                    color: '#5e76d3',
                    border: 'none',
                    marginBottom: '3px',
                    fontWeight: 'bold',
                }}
                onClick={decoratedOnClick}
            >
                {children}
            </button>
        );
    }


    return (
        <section id="FAQ">
            <div className="container-fluid mt-3 disclaimer minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h2 className="pageTitle mt-2">Frequently Asked Questions</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body faqList">
                                    {pages_data && pages_data.map((data, index) => {
                                        return (
                                            <div key={index} id={'FAQ' + (index + 1)} className="row mb-4">
                                                <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <p className="faqTitle m-0">{data.Description}</p>
                                                    </div>


                                                    {data.FAQItems && data.FAQItems.map((child, child_index) => {

                                                        return (

                                                            <Accordion className='mb-1'>
                                                                <Accordion.Item eventKey="0">
                                                                    <Accordion.Header>
                                                                        <div>{child_index + 1}. {child?.Question}</div>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body className='bg-light'>
                                                                        <div className="accordion-body" dangerouslySetInnerHTML={{ __html: child?.Answer }}></div>
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>

                                                        )

                                                        /*return (
                                                            <Accordion>
                                                                <div className="card" key={child_index}>
                                                                    <Accordion.Toggle eventKey={child_index?.toString()} className="card-header">
                                                                        <div className="d-flex flex-row justify-content-between">
                                                                            <div>{child_index + 1}. {child?.Question}</div>
                                                                        </div>
                                                                    </Accordion.Toggle>

                                                                    <div className="card-body">
                                                                        <div className="accordion-item overflow-auto">
                                                                            <Accordion.Collapse eventKey={child_index?.toString()}>
                                                                                <div className="accordion-body" dangerouslySetInnerHTML={{ __html: child?.Answer }}></div>
                                                                            </Accordion.Collapse>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion>
                                                        )*/
                                                    })
                                                    }


                                                </div>
                                            </div>
                                        )
                                    })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





